import { getLocaleDetails } from '@tribeplatform/react-components/i18n'

export const CountryLanguage = ({ locale }: { locale: string }) => {
  const { shortCode, languageName } = getLocaleDetails(locale)

  if (!shortCode) {
    return <>{languageName}</>
  }

  return (
    <div className="flex gap-2">
      <em-emoji shortcodes={shortCode} set="apple" />
      {languageName}
    </div>
  )
}
